<template>
  <div class="pt-1">
    <v-card style="border-top-left-radius: 30px; border-bottom-right-radius: 20px;"  elevation="10" class="p-2">
      <div class="flex justify-between ">
        <div>
          <Lynx-Title text="Observações" />
        </div>
        <div>
          <Lynx-Button
            text="Adicionar"
            icon="Plus"
            icon-size="3"
            size="small"
            @click.native="addLabel"
          />
        </div>
      </div>

      <div class="mb-2 w-1/4 ">
        <b-select placeholder="Todos" size="sm" style="border: 4px solid; border-radius: 10px;" v-model="selecionado">
          <option  :value="null">
            Todos
      </option>
          <option v-for="usuario in usuario_ob" :key="usuario.id" :value="usuario.id">
        {{ usuario.nome_completo }}
      </option>
        </b-select>
      </div>

      <div>
        <Lynx-Spinner size="4" v-if="loading" />

        <div v-for="(lista, index) in observacoes" :key="index">
          <b-notification
            class="mt-1"
            :closable="false"
            :type="
              isEditting == index
                ? getColor(form.status)
                : getColor(lista.status)
            "
            aria-close-label="Close notification"
          >

            <form @submit.prevent="onSubmit(lista)" class="flex flex-col">
              <label class="flex flex-col">
             
                  <label class="flex items-center mb-1">
            <b-select v-model="form.status" v-if="isEditting == index">
              <option
                v-for="status in statusOptions"
                :key="status.id"
                :value="status.value"
                v-text="status.label"
              />
            </b-select>

          </label>

                <span
                  v-text="lista.note"
                  v-show="isEditting != index && lista.note"
                />
                <div class="text-neutral-800" v-show="isEditting == index">
                  <Lynx-Textarea v-model="form.note" />
                </div>
                <!-- <span class="text-neutral-400" v-text="'nenhum comentário adicionado.'" /> -->
              </label>
              <div
                style="color: white"
                class="flex justify-between"
                v-show="isEditting == index"
              >
                <Lynx-Button
                  @click.native="cancelEdit"
                  text="Cancelar"
                  size="small"
                  type="button"
                />

                <Lynx-Button
                  text="Enviar"
                  type="submit"
                  size="small"
                  :loading="loadingButton"
                />
              </div>
              <span class="font-bold flex  justify-start">
                  <a
                    class="mr-2 rounded-full "
                    @click.prevent="editLabel(lista, index)"
                    v-if="isEditting != index"
                  >
                    <Icon-Edit class="text-neutral-100" size="4" />
                  </a>
                  <a
                    class="ml-2 rounded-full "
                    @click.prevent="excluir(lista)"
                    v-if="isEditting != index"
                  >
                    <Icon-Trash class="text-neutral-100" size="4" />
                  </a>
                  <span class="absolute right-0 mr-3" v-if="lista.usuario">{{ lista.usuario.nome_completo }}</span>
                </span>
            </form>
          </b-notification>
        </div>

        <div class="text-center">
    <!-- <v-pagination
      v-model="page"
      :length="4"
      circle
    ></v-pagination> -->
  </div>
      </div>
      <!-- <div v-if="!loading">
      <Lynx-Button text="Adicionar" icon="Plus" icon-size="3" size="small" @click.native="addLabel"
                   v-if="!currentLabel.id"/>
      <b-notification :closable="false" :type="isEditting ? getColor(form.status) : getColor(currentLabel.status)"
                      aria-close-label="Close notification">
        <form @submit.prevent="onSubmit" class="flex flex-col">
          <label class="flex items-center">
            <b-select v-model="form.status" v-if="isEditting">
              <option
                v-for="status in statusOptions"
                :key="status.id"
                :value="status.value"
                v-text="status.label"
              />
            </b-select>

          </label>
          <label class="flex flex-col">
              <span class="font-bold flex">
                Observações
              <a class=" ml-2 rounded-full p-2" @click.prevent="editLabel" v-if="!isEditting">
                <Icon-Edit class="text-neutral-100" size="3"/>
              </a>
              <a class=" ml-2 rounded-full p-2" @click.prevent="excluir" v-if="!isEditting">
                <Icon-Trash class="text-neutral-100" size="3"/>
              </a>
              </span>

            <span v-text="currentLabel.note" v-if="!isEditting && currentLabel.note"/>
            <div class="text-neutral-800" v-else-if="isEditting">
              <Lynx-Textarea v-model="form.note"/>
            </div>
            <span class="text-neutral-400" v-text="'nenhum comentário adicionado.'" v-else/>
          </label>
          <div style="color:white;" class="flex justify-between" v-if="isEditting">
            <Lynx-Button
              @click.native="cancelEdit"
              text="Cancelar"
              size="small"
              type="button"
            />
            
            <Lynx-Button
              text="Enviar"
              type="submit"
              size="small"
              :loading="loadingButton"
            />
            
          </div>
        </form>
      </b-notification>
    </div> -->
    </v-card>
  </div>
</template>

<script>
import {
  storeLabelsRequest,
  updateLabelsRequest,
  excluirLabelsRequest,
} from "../../../services/requests/labels";
import LynxTextarea from "@/components/helpers/Textarea";
import { empresasShowRequest } from "@/services/requests/empresas";
import { mapActions, mapGetters } from "vuex";
import bus from "../../../services/bus";

export default {
  name: "EmpresaLabel",
  components: { LynxTextarea },
  props: {
    labelable: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      selecionado:null,
      loading: false,
      loadingButton: false,
      currentLabel: this.labelable || {},
      modal: false,
      isEditting: -1,
      form: {},
      statusOptions: [
        {
          label: "Verde",
          value: 1,
        },
        {
          label: "Amarelo",
          value: 2,
        },
        {
          label: "Vermelho",
          value: 3,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getEmpresa", "getToken", "getUser"]),
    usuario_ob(){

       const novoArray = this.getEmpresa.label.filter(item => item.usuario !== null)
        .map(element => ({
          id: element.usuario.id,
          nome_completo: element.usuario.nome_completo
        }));
console.log(novoArray)
return novoArray
    },
    observacoes(){
      if(this.selecionado){
      return this.getEmpresa.label.filter(item => item.usuario !==    null).filter(item => item.usuario.id ===    this.selecionado)
        .map(element => (
      element
        ));
      }else{
        return this.getEmpresa.label
      }
   
    }
    
  },
  methods: {
    ...mapActions(["setEmpresa"]),
    getColor(status) {
      switch (status) {
        case 1:
          return "is-success";
        case 2:
          return "is-warning";
        case 3:
          return "is-danger";
      }
    },
    addLabel() {
      this.loading = true;
      const form = {
        labelable_type: "empresa",
        labelable_id: this.getEmpresa.id,
        status: 2,
        note: "Atenção",
        usuario_id : this.getUser.id
      };
      

      storeLabelsRequest(form)
        .then((res) => {    this.fetchEmpresa();}
        )
        .finally(() => (this.loading = false));
    },
    openModal() {
      this.modal = true;
    },
    editLabel(value, index) {
      this.form = value;
      this.isEditting = index;
    },
    cancelEdit() {
      this.isEditting = -1;
      this.form = {};
    },
    onSubmit(value) {
      this.loadingButton = true;
      this.form.usuario_id = this.getUser.id
      updateLabelsRequest(value.id, this.form)
        .then((res) => {
          this.currentLabel = res.data.data;
          this.modal = false;
          this.isEditting = -1;
          this.$snack.success("Status alterado com sucesso");
        })
        .catch(() => this.$snack.error("Não foi possivel alterar o status"))
        .finally(() => (this.loadingButton = false));
    },

    async excluir(value) {
      await this.$buefy.dialog.confirm({
        message: `tem certeza que deseja exclur esse registro`,
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.loadingButton = true;

          excluirLabelsRequest(value.id)
            .then((res) => {
              this.modal = false;
              this.isEditting = -1;
              this.$snack.success("Excluido com sucesso");
              this.fetchEmpresa();
            })
            .catch(() => this.$snack.error("Não foi possivel excluir"))
            .finally(() => (this.loadingButton = false));
        },
      });
    },
    fetchEmpresa() {
      // bus.globalLoading = true;

      empresasShowRequest(this.getEmpresa.id)
        .then((res) => {
          this.setEmpresa(res.data.data);
          // this.$router.push({ name: "empresas.show" });
        })
        .catch(() => this.$snack.error("Empresa não encontrada"))
        // .finally(() => (bus.globalLoading = false));
    },
  },
};
</script>
